import NewVOB from './NewVOB';

export default NewVOB;
